import React from 'react';

type PickDetailComponentProps = {
  children: JSX.Element;
};

function PickDetail({ children }: PickDetailComponentProps) {
  return <div className="pick-detail__route">{children}</div>;
}

export default PickDetail;
